import * as React from 'react'

function SvgFunArrowTriangleDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 9h5a.5.5 0 01.4.8L15 13l-2.6 3.467a.5.5 0 01-.8 0L9 13 6.6 9.8A.5.5 0 017 9h5z" />
    </svg>
  )
}

export default SvgFunArrowTriangleDown
